import { CustomApplication } from "src/app/CustomApplication";
import { PlanoDialog } from "../plano/plano.dialog";

export class NavegaTelaPlanoImpl implements NavegaTelaPlanoImpl {
    static async navegaTelaPlano(urlContratar: string) {
        const modalBoasVindas = await CustomApplication.instanceModalCtrl.create({
            component: PlanoDialog,
            componentProps: {
              urlContratar
            }
        });
        modalBoasVindas.present();
    }
}